export default {
    MOSH: 'mosh',
    MOSHY: 'moshy',
};
